// ute-Utils 2.0
// ADonald 11/22/2014 - Separated Utils & Animation methods out of ute.js


$(document).ready(function () {
    // Style Code Examples
    $('.ute-code').each(function(){
        $(this).html('<pre><code>' + 
            $(this).html()
            .replace(/&/mg,'&#38;')
            .replace(/</mg,'&#60;')
            .replace(/>/mg,'&#62;')
            .replace(/\"/mg,'&#34;')
            .replace(/\t/g,'  ')
            .replace(/\r?\n/g,'<br>')
            .replace(/<br><br>/g,'<br>')
            .replace(/ /g,'&nbsp;')
         + '</code></pre>');
    });
});

// $.fn.uteScrollPageTo = function (target, options, callback) {
//     if (typeof options == 'function' && arguments.length == 2) {
//         callback = options;
//         options = target;
//     }
//     var settings = $.extend({
//         scrollTarget: target,
//         offsetTop: 50,
//         duration: 500,
//         easing: 'swing'
//     }, options);
//     return this.each(function () {
//         var scrollPane = '.core';
//         var scrollTarget = (typeof settings.scrollTarget == "number") ? settings.scrollTarget : $(settings.scrollTarget);
//         var scrollY = (typeof scrollTarget == "number") ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
//         scrollPane.animate({
//             scrollTop: scrollY
//         }, parseInt(settings.duration), settings.easing, function () {
//             if (typeof callback == 'function') {
//                 callback.call(this);
//             }
//         });
//     });
// }

// function uteGetUrlParam(paramName, source){
//     paramName = paramName.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
//     var regexS = "[\\?&]"+paramName+"=([^&#]*)";
//     var regex = new RegExp(regexS);
//
//     var paramSource;
//     if(source){
//         paramSource = source;
//     }else{
//         paramSource = window.location.href;
//     }
//
//     var results = regex.exec(paramSource);
//     if(results == null){
//         return "";
//     }else{
//         return results[1];
//     }
// }

function uteUtils(){
    // Apply ute-equalize-height (Delay for all css to complete on page)
    window.setTimeout("$('[ute-equalize-height]').each(function () {$(this).uteEqualizeHeight();});", 500);
}

$.fn.uteEqualizeHeight = function(paramOverrides){
    // Set Default Params
    var params = {};
        params.height   = 0;    // 0 = Equalizes height. > 0 sets a specific height
        params.small    = true; // Run equalize on Small width
        params.big      = true; // Run equalize on Big width
        params.target   = this; // jquery DOM selector

    // Get Dom Params
    var attr = $(this).attr('ute-equalize-height');
    if(typeof attr !== 'undefined' && attr !== false && attr.length > 0){
        paramOverrides = JSON.parse(attr.replace(/'/g, '"'));
    }
    
    // Apply param overrides if exist
    if(paramOverrides){
        $.extend(params, paramOverrides);
    }

    if(params.small && _ute.device.size == "small" || params.big && _ute.device.size == "big"){
        var tallest = params.height;
        if(params.height == 0){ // Find tallest target item
            $(params.target).each(function () {
                var targetItemHeight = $(this).height();
                //console.log("height: " + targetItemHeight);
                if(targetItemHeight > tallest){
                    tallest = targetItemHeight;
                }
            });
        }
        // Set all targets to equalized height
        $(params.target).css('height', tallest + 'px').addClass('ute-equalize-height-executed');
        //console.log("Tallest height: " + tallest);
    }
}

// Set Cookie
// function uteSetCookie(name, value, path, expiredays)
// {
//     var exdate = new Date();
//     exdate.setDate(exdate.getDate() + expiredays);
//     document.cookie = name + "=" + escape(value) + ";path=" + path + ((expiredays == null) ? "" : ";expires=" + exdate.toUTCString());
// }

// Get Cookie
// function uteGetCookie(name)
// {
//     if (document.cookie.length>0)
//     {
//         c_start=document.cookie.indexOf(name + "=");
//         if (c_start!=-1)
//         {
//             c_start=c_start + name.length+1;
//             c_end=document.cookie.indexOf(";",c_start);
//             if (c_end==-1)
//                 c_end=document.cookie.length;
//
//             return unescape(document.cookie.substring(c_start,c_end));
//         }
//     }
//     return "";
// }

// uteGetTime example:
/*
$('body').prepend('<div id="timed">Timed</div>');
setInterval("showClock();",1000);
function showClock(){
    var time = uteGetTime.now();
    $('#timed').html(
        time.getFullYear() + "-" +
        uteGetTime.formatSegment(time.getMonth() + 1) + "-" +
        uteGetTime.formatSegment(time.getDate()) + " " +
        uteGetTime.formatSegment(time.getHours()) + ":" +
        uteGetTime.formatSegment(time.getMinutes()) + ":" +
        uteGetTime.formatSegment(time.getSeconds())
        )
}
*/
/*
var uteGetTime = new function() {
    this.offset = 0;
    this.calibrate = function (UTC_msec) {
        //Ignore if not a finite number
        if (!isFinite(UTC_msec)) return;

        // Calculate the difference between client and provided time
        this.offset = UTC_msec - new Date().valueOf();

        //If the difference is less than 60 sec, use the clients clock as is.
        if (Math.abs(this.offset) < 60000) this.offset = 0;
    }
    this.now = function () {
        var time = new Date();
        time.setTime(this.offset + time.getTime());
        return time;
    }
    this.formatSegment = function (v) {
        return v < 10 ? "0" + v : v;
    }
    this.calibrate_json = function (data) {
        if (typeof data === "object") {
            this.calibrate (new Date(data.datetime).valueOf() );
        } else {
            var script = document.createElement("script");
            script.type="text/javascript";
            script.src=(data||"http://json-time.appspot.com/time.json?tz=UTC") +
                "&callback=uteGetTime.calibrate_json";
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
    this.calibrate_json(); //request calibration with json
}();
*/

//** Animation Utils **//
// Bounce Function
// $.fn.uteBounce = function(magnitude, speed) {
//   var magnitude1 = Math.round(magnitude);
//   var magnitude2 = Math.round(magnitude / 3 * 2);
//   var magnitude3 = Math.round(magnitude / 3);
//
//   var speed1 = Math.round(speed);
//   var speed2 = Math.round(speed / 3 * 2);
//   var speed3 = Math.round(speed / 3);
//
//   $(this)
//     .animate({top:"-=" + magnitude1 + "px"},speed1).animate({top:"+=" + magnitude1 + "px"},speed1)
//     .animate({top:"-=" + magnitude2 + "px"},speed2).animate({top:"+=" + magnitude2 + "px"},speed2)
//     .animate({top:"-=" + magnitude3 + "px"},speed3).animate({top:"+=" + magnitude3 + "px"},speed3);
//   return this;
// };

// Drop Function
// $.fn.uteDrop = function(magnitude, speed) {
//   $(this).animate({top:"-=" + magnitude + "px"},speed).animate({top:"+=" + magnitude + "px"},speed,"linear");
//   return this;
// };

// Blink Function
// $.fn.uteBlink = function(times, speed) {
//   var numTimes = 3;
//
//   if (times > 0)
//     numTimes = times;
//
//   for(x=0; x<=numTimes; x++){
//     $(this)
//       .fadeOut(speed).fadeIn(speed);
//   }
//
//   return this;
// };

// Zoom Function
// $.fn.uteZoom = function(jsonParams) {
//   // Set paramater defaults
//   var percent = 100;
//   var speed = 0;
//
//   // Assign received paramaters
//   if(jsonParams) {
//     if (jsonParams.percent)
//       percent = jsonParams.percent;
//
//     if (jsonParams.speed)
//       speed = jsonParams.speed;
//   }
//
//   // Assign values to working vars
//   var height        = $(this).height();
//   var width         = $(this).width();
//   var zoomPercent   = (percent - 100) / 100;
//   var zoomHeight    = zoomPercent * height + height;
//   var zoomWidth     = zoomPercent * width + width;
//   var zoomTop       = (height - zoomHeight) / 2;
//   var zoomLeft      = (width - zoomWidth) / 2;
//
//   // Execute
//   $(this).animate({height: zoomHeight + "px", width: zoomWidth + "px", top: "+=" + zoomTop + "px", left: "+=" + zoomLeft + "px"}, speed);
//
//   return this;
// };

// ZoomTo Function
// $.fn.uteZoomTo = function(jsonParams) {
//   // Set paramater defaults
//   var height    = $(this).height();
//   var width     = $(this).width();
//   var speed     = 0;
//
//   // Assign received paramaters
//   if(jsonParams) {
//     if (jsonParams.height)
//       height = jsonParams.height;
//
//     if (jsonParams.width)
//       width = jsonParams.width;
//
//     if (jsonParams.speed)
//       speed = jsonParams.speed;
//   }
//
//   // Execute
//   $(this).animate({height: height + "px", width: width + "px", top: "-=" + (height / 2) + "px", left: "-=" + (width / 2) + "px"}, speed);
//
//   return this;
// };

// ZoomOut Function
// $.fn.uteZoomBy = function(jsonParams) {
//   // Set paramater defaults
//   var height    = $(this).height();
//   var width     = $(this).width();
//   var speed     = 0;
//
//   // Assign received paramaters
//   if(jsonParams) {
//     if (jsonParams.height)
//       height = jsonParams.height;
//
//     if (jsonParams.width)
//       width = jsonParams.width;
//
//     if (jsonParams.speed)
//       speed = jsonParams.speed;
//   }
//
//   // Execute
//   $(this).animate({height: "+=" + height + "px", width: "+=" + width + "px", top: "-=" + (height / 2) + "px", left: "-=" + (width / 2) + "px"}, speed);
//
//   return this;
// };

//** UTILS [End] **//
